module.exports = __webpack_public_path__ + "static/img/img-back-industriales.e2c2cf8.jpg";